export default "__VITE_ASSET__C07g0aWK__"